export const Person = {
  getPerson: {
    url: "/person",
    method: ["GET"]
  },
  infoUpdate: {
    url: "/person",
    method: ["PUT"],
    required: [
      "firstName",
      "lastName",
      "phone",
      "cpf",
      "birthday",
      "newsletter"
    ]
  },
  identify: {
    url: "/person/identify",
    method: ["GET"]
  },
  info: {
    //url: "/person/{id}",
    url: "/person/info",
    method: ["GET"]
  },
  notification: {
    url: "/person/notification",
    method: ["GET"]
  },
  readNotification: {
    url: "/person/notification/read?notificationId={notificationId}",
    method: ["POST", "GET"],
    //required: ["notificationId"]
  },
  reward: {
    url: "/person/reward",
    method: ["GET"]
  },
  badge: {
    url: "/person/badge",
    method: ["GET"]
  },
  subscribers: {
    url: "/person/subscribers",
    method: ["GET"]
  },
  editionsReceived: {
    url: "/person/editionsreceived",
    method: ["GET"]
  },
  listInvites: {
    url: "/person/invites",
    method: ["GET"]
  },
  instagram: {
    url: "/person/instagram",
    method: ["GET"]
  },
  instagramRegister: {
    url: "/person/instagram/register",
    method: ["POST"],
    required: [
      "redirectUrl",
      "code",
      "personId"
    ]
  },
  instagramDisconnect: {
    url: "/person/instagram/disconnect",
    method: ["POST"]
  },
  updatePassword: {
    url: "/person/password",
    method: ["PUT"],
    required: [
      "oldPassword",
      "newPassword",
      "newPasswordConfirmation"
    ]
  },
  updatePersonInviter: {
    url: "/person/personinviter",
    method: ["PUT"],
    required: ["personInviterId"]
  },
  editCouponName: {
    url: "/person/editCouponName",
    method: ["PUT"]
  }
};
